import { useEffect, useState } from 'react';

export const useEthereumInjected = () => {
  const [isInjected, setIsInjected] = useState(false);

  useEffect(() => setIsInjected(!!window.ethereum), []);

  return isInjected;
};
